import { Button } from "antd";
import { useDraftBailiffForward } from "hook/draft/bailiff/useDraftBailiffForward";
import React from "react";
import { FaRegShareFromSquare } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { draftBailiffDetailSelector } from "store/bailiff/draft/bailiff/draft_bailiff.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DetailForward = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpen } = useDraftBailiffForward();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(draftBailiffDetailSelector);
  const isForwarded = detail?.status === "ready for forwarding"; // làm rõ forwarded hay forwarding ?

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Button
      disabled={!isForwarded}
      type="primary"
      icon={
        <span className="anticon">
          <FaRegShareFromSquare />
        </span>
      }
      onClick={handleOpen}
      iconPosition="end"
    >
      Gửi Kết Quả
    </Button>
  );
};
export default DetailForward;
